import Axios from "axios";
import CONFIG from "../model/TSConfig";
import type GenericJetpackBackendResponse from "../model/responsemodel/GenericJetpackBackendResponse";
import type AnalyticsData from "../app/04_Analytics/model/AnalyticsData";
import { LANGUAGE } from "../utils/i18n/i18n";
import moment from "moment-timezone";

export default async function fetchDashboardAnalytics(
  ownerId: string,
  sts: number,
  ets: number,
  isAll: boolean,
  avgBasket: number,
  currencyCTAValue: number,
  token: string,
  subUnits: number
): Promise<GenericJetpackBackendResponse<AnalyticsData>> {
  const res = await Axios({
    method: "GET",
    url: `${CONFIG.jetpackAPIUrl}/stats`,
    headers: { Authorization: `Bearer ${token}` },
    params: {
      ownerId,
      sts,
      ets,
      isAll,
      avgBasket,
      currencyCTAValue,
      token,
      lng: LANGUAGE,
      tz: moment.tz.guess(),
      subUnits
    }
  });

  return res.data;
}
